import { apiRequest } from './api.js';

export function createDashboardService(helium) {
	const statsChannel = helium.factory('dashboard:stats', {
		accounts: '—',
		mrr: '—',
		churn: '—',
		active: '—'
	});
	
	const getStats = async (forceRefresh = false, signal) => {
		if (!forceRefresh) {
			const cached = await apiRequest('/api/v1/admin/dashboard/stats', { signal }, true);
			if (cached) {
				statsChannel.send(() => ({
					accounts: cached.totalAccounts.toLocaleString(),
					mrr: `$${cached.mrr.toLocaleString()}`,
					churn: cached.churnRate.toFixed(1),
					active: cached.activeSubscriptions.toLocaleString()
				}));
				return cached;
			}
		}
		
		const stats = await apiRequest('/api/v1/admin/dashboard/stats', { signal }, false);
		
		statsChannel.send(() => ({
			accounts: stats.totalAccounts.toLocaleString(),
			mrr: `$${stats.mrr.toLocaleString()}`,
			churn: stats.churnRate.toFixed(1),
			active: stats.activeSubscriptions.toLocaleString()
		}));
		
		return stats;
	};
	
	return { statsChannel, getStats };
}
